"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPOSITORY_PROVIDER = void 0;
exports.REPOSITORY_PROVIDER = {
    GITLAB: 'GITLAB'
};
//# sourceMappingURL=repositoryProvider.js.map